var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", attrs: { id: "bruteforcesettings" } },
    [
      _c("h2", [
        _vm._v(_vm._s(_vm.t("bruteforcesettings", "Brute-force IP whitelist")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "settings-hint" }, [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.t(
                "bruteforcesettings",
                "To whitelist IP ranges from the brute-force protection specify them below. Note that any whitelisted IP can perform authentication attempts without any throttling. For security reasons, it is recommended to whitelist as few hosts as possible or ideally even none at all."
              )
            ) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("table", { attrs: { id: "whitelist-list" } }, [
        _c(
          "tbody",
          _vm._l(_vm.items, function(item) {
            return _c("BruteForceItem", {
              key: item.id,
              attrs: { item: item },
              on: { delete: _vm.deleteWhitelist }
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h3", [
        _vm._v(_vm._s(_vm.t("bruteforcesettings", "Add new whitelist")))
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.addWhitelist($event)
            }
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newWhitelist.ip,
                expression: "newWhitelist.ip"
              }
            ],
            attrs: {
              id: "ip",
              type: "text",
              name: "ip",
              placeholder: "2001:db8::"
            },
            domProps: { value: _vm.newWhitelist.ip },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.newWhitelist, "ip", $event.target.value)
              }
            }
          }),
          _vm._v("/\n\t\t"),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newWhitelist.mask,
                expression: "newWhitelist.mask"
              }
            ],
            attrs: {
              id: "mask",
              type: "number",
              name: "mask",
              placeholder: "64"
            },
            domProps: { value: _vm.newWhitelist.mask },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.newWhitelist, "mask", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "button",
            attrs: { type: "submit" },
            domProps: { value: _vm.t("bruteforcesettings", "Add") }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }